var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "NodeViewWrapper",
    {
      ref: "customTagsAndFieldsTrigger",
      attrs: { as: "span", hash: _vm.hash }
    },
    [
      _c(
        "span",
        {
          class: _vm.classes,
          attrs: {
            hash: _vm.hash,
            draggable: _vm.isDraggable,
            "data-drag-handle": ""
          },
          on: {
            mouseover: _vm.handleMouseOver,
            mouseleave: _vm.handleMouseLeave,
            focus: _vm.handleFocus,
            blur: _vm.handleBlur,
            dragstart: _vm.handleDragStart,
            dragend: _vm.handleDragEnd
          }
        },
        [
          _vm.showDragIcon
            ? _c("CompassIcon", {
                attrs: { icon: "ai-drag-plan", size: "extra-small" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "ai"
            ? _c("CompassIcon", {
                staticClass: "custom-tags-and-fields__ai-icon",
                attrs: { icon: "ai-sparkles-simple" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "typographies-paragraph-small-semibold" }, [
            _vm._v("\n            " + _vm._s(_vm.label) + "\n        ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassPopover",
        {
          attrs: {
            isVisible: _vm.showAIBlockPopover,
            placement: "bottom-start",
            customClass: "rich-text-style custom-tags-and-fields__popover",
            triggerRef: "customTagsAndFieldsTrigger"
          },
          on: {
            close: _vm.hideAIBlockPopover,
            mouseleave: _vm.handleMouseLeave
          }
        },
        [
          _c(
            "div",
            { staticClass: "custom-tags-and-fields__popover-header" },
            [
              _c("span", { staticClass: "typographies-paragraph-small-bold" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t.__("richtext.CustomTagsAndFields.popover_title_ai")
                    ) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("CompassIcon", {
                staticClass: "custom-tags-and-fields__ai-icon",
                attrs: { icon: "ai-sparkles-simple" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "custom-tags-and-fields__popover-content rich-text-style",
            domProps: { innerHTML: _vm._s(_vm.replaceTagsWithSpan(_vm.prompt)) }
          }),
          _vm._v(" "),
          _vm.isDraggable
            ? _c(
                "div",
                { staticClass: "custom-tags-and-fields__popover-footer" },
                [
                  _c("ButtonAI", {
                    attrs: {
                      label: _vm.$t.__("common.labels.edit"),
                      type: "secondary",
                      leftIcon: "edit"
                    },
                    on: { click: _vm.handleEdit }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }